<template>
    <div class="ainak-header">
        <div class="ainak-header-title">
            <router-link to="/home" class="router-link-format"> <img class="ainak-logo" :src='image' alt=""/></router-link>
        </div>
        <div class="ainak-header-content">
            <div class="ainak-header-content-container">
<!-- 
                <router-link to="/home" class="router-link-format">Home</router-link>
                <router-link to="/profile" class="router-link-format">Profile</router-link>
                <a @click="handleMenuClicks('logout')" class="router-link-format">LogOut</a> -->
                
                <!-- <router-link to="/home" class="router-link-format"><b-icon icon="home" type="is-primary"></b-icon></router-link>
                <router-link to="/home" class="router-link-format"><b-icon class="dropdown-icon" icon="account" type="is-primary"></b-icon></router-link>
                <router-link to="/home" class="router-link-format"><b-icon class="dropdown-icon" icon="logout" type="is-danger"></b-icon></router-link>
                 -->

                <router-link to="/home" class="router-link-format">Home</router-link>
                <!--<router-link to="/soon" class="router-link-format">Manage</router-link>-->
                <!--<router-link to="/soon" class="router-link-format">Documentation</router-link>-->
                <!--<router-link to="/api" class="router-link-format"> <h1>APIs</h1></router-link>-->
                <!--<router-link to="/profile" class="router-link-format-profile"><img :src='dummy_profile' alt="" class="profile-pic"/> </router-link>-->
                
                <div v-if="!showDropdown" @mouseover="showDropdown = true" @click="showDropdown = true;" class="header-dropdown router-link-format-profile">
                    <img :src='dummy_profile' alt="" class="profile-pic"/>
                </div>
                <div v-if="showDropdown" class="header-dropdown router-link-format-profile" @click="showDropdown = false;" @mouseleave="showDropdown = false">
                    <img :src='dummy_profile' alt="" class="profile-pic"/>
                    <div class="dropdown-content">
                        <span @click="handleMenuClicks('profile')">
                            <b-icon class="dropdown-icon" icon="account" type="is-primary" size="is-small"> </b-icon>
                            <h1>Profile</h1>
                        </span>
                        <span @click="handleMenuClicks('logout')">
                            <b-icon class="dropdown-icon" icon="logout" type="is-danger" size="is-small"> </b-icon>
                            <h1>Logout</h1>
                        </span>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AinakHeader",
        data: function () {
            return {
                image: require('@/assets/images/ainak-logo-header.png'),
                dummy_profile: require('@/assets/images/dummy-profile.png'),
                showDropdown: false
            }
        },
        methods: {
            handleMenuClicks(goto){

                switch (goto) {
                    case 'profile':
                        this.$router.push('Profile');
                        break;
                    case 'logout':
                        this.$store.dispatch('resetState')
                            .then(() => {
                                console.log("success - Logged out");
                                this.$router.push('Login');
                            })
                            .catch(() => {
                                console.log("failed- Logged out")
                            });
                        break;
                }

            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/css/colors.scss";


     .ainak-header {
        width: 100%;
        top: 0;
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-areas: "header-title header-content";
        grid-template-rows: 1fr;
        grid-template-columns: 20% 80%;
        overflow: hidden;
    }

    .ainak-header .ainak-header-title {
        grid-area: header-title;
        display: flex;
        text-align: left;
    }

    .ainak-header-title .ainak-logo {
        width: 50%;
        height: auto;
        background-size: cover;
        align-self: center;
    }

    .ainak-header .ainak-header-content {
        grid-area: header-content;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .ainak-header-content .ainak-header-content-container{
        display: flex;
        flex-direction: row;
        align-self: center;
        justify-content: flex-end;
    }

    .ainak-header-content-container .profile-pic{
        width: 5%;
        height: auto;
        background-size: cover;
        border-radius: 50%;
        border: 1px solid $primary-color;
        align-self: center;
    }

    .ainak-header-content-container h1{
        align-self: center;
        margin: 0 5% 0 0;
        font-family: 'Roboto', sans-serif;
        font-size: 100%;
        color: $body-text-color;
    }

    .router-link-format{
     align-self: center;
     margin: 0 5% 0 0;
     font-family: 'Roboto', sans-serif;
     font-size: 100%;
     color: $body-text-color;
     text-decoration: none;
     padding: 0 10px;
        .profile-pic{
            width: 100%;
            height: auto;
            background-size: cover;
            border-radius: 50%;
            border: 1px solid $primary-color;
            align-self: center;
        }
    }

    .router-link-format-profile{
        text-decoration: none;
        width: 5%;

        .profile-pic{
            width: 100%;
            height: auto;
            background-size: cover;
            border-radius: 50%;
            border: 1px solid $primary-color;
            align-self: center;
        }
    }

    /*!*Dropdown*/
    .header-dropdown {
        position: relative;
        overflow: hidden;
        width: 5%;

        .dropdown-content {
            display: block;
            transform: translate(-70% , 0);
            position: fixed;
            background-color: white;
            min-width: 15%;
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
            z-index: 1;
            border: 1px solid #eee;


            span{
                background: white;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                padding: 3% 5%;
                cursor: pointer;

                h1{
                    flex: 1;
                    text-align: left;
                    font-family: 'Roboto Slab', sans-serif;
                    font-size: 80%;
                    font-weight: normal;
                    color: $body-text-color;
                    background-color: transparent;
                }

                .dropdown-icon{
                    padding-right: 20%;
                    background-color: transparent;
                }

                .dropdown-icon:hover{
                    background-color: transparent;
                }
            }

            span:nth-child(4){
                border-bottom: 1px solid $primary-color-thirty !important;
                padding-bottom: 6%;
                margin-bottom: 3%;
            }

            span:nth-child(6){
                border-bottom: 1px solid $primary-color-thirty !important;
                padding-bottom: 6%;
                margin-bottom: 3%;
            }

            span:hover{
                background-color: $primary-color-thirty;
            }
        }
    }
    
    .mdi-24px.mdi-set, .mdi-24px.mdi:before {
        font-size: 200px;
    }



</style>